export default () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    version="1.1"
    baseProfile="tiny"
    id="Layer_1"
    x="0px"
    y="0px"
    viewBox="93 0 774 560"
    xmlSpace="preserve"
  >
    <g>
      <path d="M480 275.2L793.6 11.6c-14.6-6.4-30.6-9.9-47.5-9.9H213.9c-16.9 0-32.9 3.5-47.5 9.9L480 275.2z" />
      <path d="M524 336.2c-12.8 10.7-28.4 16.1-44 16.1s-31.3-5.4-44-16.1L110.1 62.3c-9.9 17.4-15.6 37.5-15.6 58.8v317.8 c0 65.7 53.7 119.4 119.4 119.4h532.3c65.7 0 119.4-53.7 119.4-119.4V121.1c0-21.3-5.7-41.4-15.6-58.8L524 336.2z" />
    </g>
  </svg>
);
